import {
	Autocomplete,
	Box,
	IconButton,
	Paper,
	TextField,
	Tooltip,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import type { PurchaseOrder } from "../models/RollsReceived";

interface Props {
	purchaseOrders: PurchaseOrder[];
	selectedPO: PurchaseOrder | null;
	loading: boolean;
	onSelect: (po: PurchaseOrder | null) => void;
	onRefresh: () => void;
}

const optionLabel = (po: PurchaseOrder): string =>
	po.SupplierName
		? `${po.Number?.trim()} — ${po.SupplierName}`
		: `${po.Number?.trim()}`;

export const RollsReceivedToolbar = ({
	purchaseOrders,
	selectedPO,
	loading,
	onSelect,
	onRefresh,
}: Props) => {
	return (
		<Paper
			elevation={3}
			sx={{
				p: 1.5,
				mb: 1,
				display: "flex",
				gap: 2,
				alignItems: "center",
				flexWrap: "wrap",
			}}
		>
			<Autocomplete
				size="small"
				sx={{ minWidth: 360 }}
				options={purchaseOrders}
				value={selectedPO}
				loading={loading}
				getOptionLabel={optionLabel}
				isOptionEqualToValue={(o, v) => o.Id === v.Id}
				onChange={(_e, option) => onSelect(option)}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Purchase Order"
						placeholder="Search by number or supplier"
					/>
				)}
			/>
			<Tooltip title="Reload purchase orders">
				<span>
					<IconButton
						onClick={onRefresh}
						disabled={loading}
						size="small"
						sx={{
							bgcolor: "primary.main",
							color: "white",
							width: 28,
							height: 28,
							"&:hover": { bgcolor: "primary.dark" },
							"&.Mui-disabled": {
								bgcolor: "action.disabledBackground",
								color: "action.disabled",
							},
						}}
					>
						<RefreshIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</span>
			</Tooltip>
			<Box sx={{ flex: 1 }} />
		</Paper>
	);
};
